<template>
  <modal
    size="large"
    class="event-modal"
    @close="$emit('close')"
  >
    <template #header>
      <event-header
        has-event
        large
        active="active"
        :image="eventData.image"
        :title="eventData.title"
        :subtitle="eventData.subtitle"
        :tag-right="eventData.tagRight"
      />
    </template>

    <transition name="transition-fade">
      <div
        v-if="loading"
        class="gap-column__loading"
      >
        <loader-spinner :size="1.5" />
      </div>
    </transition>

    <transition-group name="transition-fade">
      <template v-if="!loading">
        <div
          v-if="$store.state.eventInformation[eventData.event.event_type]['description_' + $i18n.locale]"
          key="description"
          class="event-modal__description"
        >
          <div
            class="event-modal__running-text"
            v-html="$store.state.eventInformation[eventData.event.event_type]['description_' + $i18n.locale]"
          />
        </div>

        <event-day
          key="today"
          :reservation="eventData.reservation"
          :date="eventData.date"
        />

        <div
          key="more_dates"
          class="event-modal__more-dates"
        >
          <div class="event-modal__more-dates-header">
            <headline
              level="3"
              class="event-modal__section-title"
            >
              {{ $t('allDates') }}
            </headline>
            <month-picker
              :selected="eventMonthId"
              @date="handleDateChange"
            />
          </div>

          <div
            v-if="eventDates"
            class="event-modal__more-dates-list"
          >
            <event-day
              v-for="date in eventDates"
              :key="date"
              :reservation="eventData.reservation"
              :date="date"
            />
          </div>
        </div>
      </template>
    </transition-group>
  </modal>
</template>

<script>
import eventDay from './eventDay.vue'
import eventHeader from './eventHeader.vue'
import headline from './headline.vue'
import loaderSpinner from './loaderSpinner.vue'
import modal from './modal.vue'
import monthPicker from './monthPicker.vue'

import api from '../api.js'
import dateHelper from '../functions/dateHelper.js'

export default {
  name: 'CEventModal',

  components: {
    eventDay,
    eventHeader,
    headline,
    loaderSpinner,
    modal,
    monthPicker
  },

  props: {
    eventData: {
      type: Object,
      required: true
    }
  },

  emits: ['close'],

  data () {
    return {
      loading: true,
      currentSelectedDateId: ''
    }
  },

  computed: {
    eventMonthId () {
      const date = dateHelper.dateFromString(this.eventData.date)
      return (date.getFullYear() + '-' + (date.getMonth() + 1))
    },

    eventDates () {
      const dateComponents = this.currentSelectedDateId.split('-')
      const year = parseInt(dateComponents[0])
      const month = parseInt(dateComponents[1])

      if (!(year in this.$store.state.eventsByType)) {
        return false
      }

      if (!(month in this.$store.state.eventsByType[year])) {
        return false
      }

      const _eventDates = {}
      for (const dayId in this.$store.state.eventsByType[year][month]) {
        let dateStr = year + '-'
        dateStr += ((month < 10) ? '0' : '') + month + '-'
        dateStr += ((dayId < 10) ? '0' : '') + dayId + '-'
        _eventDates[dayId] = dateStr
      }
      return _eventDates
    }
  },

  created () {
    this.currentSelectedDateId = this.eventMonthId

    api.get('events/?event_type=' + this.eventData.event.event_type).then(response => {
      this.$store.state.priceGroups = response.data.price_groups
      this.$store.state.eventInformation[this.eventData.event.event_type] = response.data.information
      this.$store.state.eventsByType = response.data.dates

      // EET
      const list = 'Ticketapp Event-Teaser'
      const teaserProduct = {
        name: 'Ticket ' + this.eventData.event.type_name,
        list: list,
        date: this.eventData.date,
        id: 'wt.e-' + this.eventData.event.event_type
      }
      this.$tracking.eetEventProductView(teaserProduct)

      this.loading = false
    })
  },

  methods: {
    handleDateChange (dateId) {
      this.currentSelectedDateId = dateId
    }
  }
}
</script>

<i18n locale="en">
{
  "allDates": "All Dates"
}
</i18n>

<i18n locale="de">
{
  "allDates": "Alle Termine"
}
</i18n>

<style lang="scss">
@import "../css/variables";

.event-modal__description {
  padding-bottom: $gutter-sm;
  margin-bottom: $gutter-sm;
  border-bottom: $border-gap;

  @media (min-width: $breakpoint-md) {
    padding-bottom: $gutter-md;
    margin-bottom: $gutter-md;
  }
}

.event-modal__running-text {
  > :last-child {
    margin-bottom: 0;
  }
}

.event-modal__section-title {
  @media (min-width: $breakpoint-md) {
    margin-bottom: $gutter-sm;
  }
}

.event-modal__more-dates-header {
  @media (min-width: $breakpoint-md) {
    margin-bottom: $gutter-sm;
  }
}

.event-modal__more-dates-list {
  > :last-child {
    margin-bottom: 0;
  }
}
</style>
